module.exports = __webpack_public_path__ + "img/dialog-close.ef472da7.svg";